import { Button, Grid, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Edit } from "@material-ui/icons";
import LogoutIcon from '@mui/icons-material/Logout';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MessageRounded } from "@material-ui/icons";
import { Link } from 'react-router-dom';
import {
    getSampleAccessioning
} from "../../actions/GenomicsResearchAction";
import TicketCommentsModal from "../../components/comment";
import { flexbox } from "@mui/system";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem 2rem 2rem",
            width: "100%",
        },

        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        text: { color: "black" },
    })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
interface Props {
    getSampleAccessioning: any;
    samplesAccessioning: any;
    setSampleAssId: any;
    setValue: any;
    setOnboardingActionType: any;
}
const StopsPlace: React.FC<Props> = ({
    getSampleAccessioning,
    samplesAccessioning,
    setSampleAssId,
    setValue,
    setOnboardingActionType,
}) => {
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")
    useEffect(() => {
        getSampleAccessioning();
    }, []);

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = samplesAccessioning?.links && samplesAccessioning?.links?.next.split("?")[1];
            getSampleAccessioning(url);
        } else if (newPage < page) {
            let url = samplesAccessioning?.links && samplesAccessioning?.links?.previous.split("?")[1];
            getSampleAccessioning(url);
        }
        setPage(newPage as number);
    };
    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };
    return (
        <Grid container spacing={2} style={{ marginTop: 10 }}>
            <Grid container style={{ marginTop: 10 }}>
                <TableContainer
                    className={classes.tableContainer}
                    component={Paper}
                    style={{ maxHeight: "470px", maxWidth: "92vw", display: "flex" }}
                >
                    <Table stickyHeader aria-label="simple table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center">Client Name</StyledTableCell>
                                <StyledTableCell align="center">Institute Name</StyledTableCell>
                                <StyledTableCell align="center">Dealer Firm Name</StyledTableCell>
                                <StyledTableCell align="center">Sample Recevied Date</StyledTableCell>
                                <StyledTableCell align="center">Samples(P/O)</StyledTableCell>
                                <StyledTableCell align="center">Pass Sample</StyledTableCell>
                                <StyledTableCell align="center">Fail Sample</StyledTableCell>
                                <StyledTableCell align="center">Project Initation Call</StyledTableCell>
                                <StyledTableCell align="center">SIF File</StyledTableCell>
                                <StyledTableCell align="center">TRF P/O</StyledTableCell>
                                <StyledTableCell align="center">Quotation</StyledTableCell>
                                <StyledTableCell align="center">Additional File</StyledTableCell>
                                <StyledTableCell align="center">Sample Condition Report</StyledTableCell>
                                <StyledTableCell align="center">Comments</StyledTableCell>
                                <StyledTableCell align="center">Edit</StyledTableCell>
                                <StyledTableCell align="center">Action</StyledTableCell>
                                <StyledTableCell align="center">Register Failed Samples</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {samplesAccessioning && samplesAccessioning?.results && samplesAccessioning?.results?.length > 0 && samplesAccessioning?.results?.map((data: any, index: any) => {
                                return (
                                    <StyledTableRow >
                                        <StyledTableCell align="center">
                                            {data.scientist?.name || "NA"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.institute?.name || "NA"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.dealer?.firmName || "NA"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.createdAt !== null ? new Date(data?.createdAt).toLocaleString() : "NA"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.poCount}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.passedCount}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.failedCount}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.initiationCall === true ? "Yes" : "No"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.sifFile ? <><a href={data?.sifFile} target="_blank" rel="noopener noreferrer">View</a><br /></> : null}
                                            {data?.accessions && data?.accessions?.map((val: any) => {
                                                return (
                                                    val?.sifFile ? <><a href={val?.sifFile} target="_blank" rel="noopener noreferrer">View</a><br /></> : null
                                                )
                                            })}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.trfPo ?
                                                <a href={data?.trfPo} target="_blank" rel="noopener noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.quotation ?
                                                <a href={data?.quotation} target="_blank" rel="noopener noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.additional ?
                                                <a href={data?.additional} target="_blank" rel="noopener noreferrer">View</a>
                                                : "N/A"}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.sample?.qcReport ? <><a href={data?.sample?.qcReport} target="_blank" rel="noopener noreferrer">View</a><br /></> : ""}
                                            {data?.accessions && data?.accessions?.map((val: any) => val?.qcReport ? <><a href={val?.qcReport} target="_blank" rel="noopener noreferrer">View</a><br /></> : "")}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            {data?.comment !== "" ?
                                                <div>
                                                    <MessageRounded
                                                        onClick={() => handleClick(data)}
                                                    />
                                                </div>
                                                : ""}
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                            >
                                                <Edit onClick={() => {
                                                    setSampleAssId(data)
                                                    setValue(1)
                                                    setOnboardingActionType("Edit Onboard SampleAccessioning")
                                                }} />
                                            </Button>
                                        </StyledTableCell>
                                        <StyledTableCell align="center">
                                            <Link to={`/dashboard/gnre/createprojects/${data?._id}`} style={{ textDecoration: "none" }}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    disabled={data?.isProjectCreated === true || data?.inspectionStatus === "Fail"}
                                                >
                                                    Create Project
                                                </Button>
                                            </Link>
                                        </StyledTableCell>
                                        {data?.failedCount !== 0 ?
                                            <StyledTableCell align="center">
                                                <Link to={`/dashboard/gnre/failedSamples/${data?._id}`} style={{ textDecoration: "none" }}>
                                                    <Button
                                                        variant="contained"
                                                        style={{ color: "Red", backgroundColor: "skyblue" }}
                                                    >
                                                        <LogoutIcon />
                                                    </Button>
                                                </Link>
                                            </StyledTableCell>
                                            : ""}
                                    </StyledTableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                colSpan={3}
                                count={samplesAccessioning?.count || 0}
                                rowsPerPage={samplesAccessioning?.page_size}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                        </TableFooter>
                    </Table>
                </TableContainer>
                <TicketCommentsModal
                    openModal={openModal}
                    setopenModal={setopenModal}
                    rundata={runData}
                />
            </Grid>
        </Grid>
    );
};
const mapStateToProps = (state: any) => ({
    samplesAccessioning: state.GenomicsCAReducer.samplesAccessioning,

});
export default connect(mapStateToProps, {
    getSampleAccessioning
})(StopsPlace);
